import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { Rarity, Sport } from '@sorare/core/src/__generated__/globalTypes';
import { HeadlineL } from '@sorare/core/src/atoms/typography';
import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { LEGACY_PLAYER_SHOW } from '@sorare/core/src/constants/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { scarcityMessages } from '@sorare/core/src/lib/scarcity';

type Props = {
  player: {
    slug: string;
    displayName: string;
  };
  rarity: Rarity;
  sport: Sport;
};

const SecondaryMarketStackedTitle = styled(HeadlineL)`
  display: inline;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &,
  & a {
    color: var(--c-white);
  }

  & span {
    margin-left: var(--unit);
    color: var(--c-nd-600);
  }
`;

export const MarketStackTitle = ({ player, rarity, sport }: Props) => {
  const { generateSportContextPath } = useSportContext();
  const playerUrl = generateSportContextPath(LEGACY_PLAYER_SHOW, {
    params: { slug: player.slug },
    sport,
  });

  return (
    <PageHeader
      customTitle={
        <SecondaryMarketStackedTitle as="h3">
          <Link to={playerUrl}>{player.displayName}</Link>
          <span>
            <FormattedMessage {...scarcityMessages[rarity]} />
          </span>
        </SecondaryMarketStackedTitle>
      }
    />
  );
};
